import React from 'react';

// Multi-line sibling of FloatingInput.jsx — same floating-label visual
// language (rounded-xl border-2 bg-gray-50/50, label that shrinks and
// floats up once there's a value or focus) but backed by a <textarea>
// instead of a single-line <input>, for fields like Config > General >
// Meta Description that need more than one line to comfortably edit.
const FloatingTextarea = ({ label, name, value, onChange, error, rows = 3, ...props }) => {
  const inputId = `textarea-${name || label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className="relative w-full mb-1">
      <div className="relative">
        <textarea
          {...props}
          id={inputId}
          value={value}
          onChange={onChange}
          placeholder=" "
          rows={rows}
          className={`peer w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-gray-50/50 resize-none
          rounded-xl border-2 transition-all outline-none focus:outline-none focus:ring-0
          ${error ? 'border-red-400 focus:border-red-500' : 'border-gray-100 focus:border-[var(--primary-color)]'}
          ps-4`}
        />

        <label
          htmlFor={inputId}
          className={`absolute text-xs font-bold uppercase tracking-widest transition-all duration-200
          cursor-text pointer-events-auto
          peer-placeholder-shown:text-sm peer-placeholder-shown:font-medium peer-placeholder-shown:lowercase
          peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs peer-focus:font-bold peer-focus:uppercase
          top-2 text-gray-400 peer-focus:text-[var(--primary-color)]
          start-4
          ${value ? 'top-2 text-xs font-bold uppercase' : ''}`}
        >
          {label}
        </label>
      </div>

      {error && (
        <p className="text-[10px] text-red-500 font-bold mt-1 ms-2 uppercase tracking-tight">
          {error}
        </p>
      )}
    </div>
  );
};

export default FloatingTextarea;
